import { Component, OnInit } from '@angular/core';
import { TestsService } from 'src/app/shared';

@Component({
  selector: 'app-section-status',
  templateUrl: './section-status.component.html',
  styleUrls: ['./section-status.component.scss']
})
export class SectionStatusComponent implements OnInit {

  section: any =[];

  constructor(
    private TestsService: TestsService,

  ) { }

  ngOnInit() {
  }

  
}
